<template>
  <div class="filter-local-tree">
    <nestable-tree id="nestable"
                   :value="selectedLocalsObjectIds"
                   :options="isEdit ? isEditedLocals : locals"
                   :always-open="true"
                   :normalizer="normalizer"
                   :no-options-text="$t('message.automation.message.noSpotRegistered')"
                   :placeholder="$t('message.generics.message.spots')"
                   @select="emitSelect"
                   @deselect="emitDeselect">
      <div slot="option-label"
           slot-scope="{ node }">
        <filter-local-tree-item :node="node" />
      </div>
    </nestable-tree>
  </div>
</template>

<script>
import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
import NestableTree from "@/components/generic/nestable/tree/NestableTree";

export default {
  components: {
    NestableTree,
    FilterLocalTreeItem,
  },

  data() {
    return {
      localsLoaded: false,
      isEditedLocals: [],
      selectedLocalsObjectIds: [],
      normalizer(node) {
        return {
          id: node.localTreeId,
          label: node.name,
          children: node.children,
        };
      },
    };
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    locals: {
      type: Array,
    },
    automationId: {
      type: String,
    },
    item: {
      type: Object,
    },
  },

  computed: {
    isEdit() {
      return !!this.item;
    },
  },

  async mounted() {
    if (this.isEdit) {
      this.isEditedLocals = await this.$api.core.loginTypes.getLocalTree(
        this.item.id
      );
      this.removeLastChildren(this.isEditedLocals);
      this.value.map((objId) => {
        this.isEditedLocals.map((node) => {
          this.addLocalTreeId(node, objId);
        });
      });
    }
  },

  methods: {
    emitSelect(val) {
      this.$emit("select", val);
    },
    emitDeselect(val) {
      this.$emit("deselect", val);
    },

    removeLastChildren(locals) {
      for (const local of locals) {
        if (local.children.length > 0) {
          this.removeLastChildren(local.children);
        } else {
          local.children = undefined;
        }
      }

      return locals;
    },
    addLocalTreeId(node, objId) {
      if (node.type === 1 && node.objectId === objId) {
        this.selectedLocalsObjectIds.push(node.localTreeId);
      }

      if (node.type === 0) {
        if (!node.children) {
          return;
        } else {
          node.children.map((childNode) => {
            this.addLocalTreeId(childNode, objId);
          });
        }
      }
    },
  },

  beforeDestroy() {},

  mixins: [],
};
</script>

<style lang="scss" >
#nestable {
  .vue-treeselect__control {
    display: none !important;
  }
  .vue-treeselect__menu-container {
    position: static !important;

    .vue-treeselect__menu {
      position: static !important;
      border: none;

      .vue-treeselect__checkbox {
        width: 15px;
        height: 15px;
      }

      .vue-treeselect__checkbox--checked {
        .vue-treeselect__check-mark {
          margin-left: 2px;
          margin-top: 1px;
        }
      }

      .vue-treeselect__checkbox--indeterminate {
        .vue-treeselect__minus-mark {
          margin-left: 2px;
          margin-top: 1px;
        }
      }

      .nestable-tree-option {
        font-size: 16px;

        svg {
          height: 20px !important;
        }

        i {
          font-size: 20px;
        }

        .filter-local-tree-item-icon {
          width: 20px !important;
        }
      }
    }
  }
}
</style>
